module.exports = __webpack_public_path__ + "static/media/login_back_xork.2a36dc83.jpg";